import clsx from 'clsx'
import { useState, type FunctionComponent } from 'react'

import { useTranslate } from '../../contexts/TranslationContext'
import SvgFilter from '../../svg/icons/Filter'
import { ProductFilterControlPanel, type ProductFilterControl } from '../filter/ProductFilterControl'
import { Button } from '../shared/Button'
import { Hidden } from '../shared/Hidden'
import { LoadingSpinner } from '../shared/LoadingSpinner'
import { Modal } from '../shared/Modal'
import style from './AdvancedFilter.module.sass'

type AdvancedFilterProps = {
	title: string
	isLocked?: boolean
	openLoginModal: () => void
	productsTotal?: number
	isLoading?: boolean
	productFilterControl?: ProductFilterControl
}

export const AdvancedFilter: FunctionComponent<AdvancedFilterProps> = ({
	title,
	openLoginModal,
	isLocked = false,
	productFilterControl,
	productsTotal,
	isLoading = false,
}) => {
	const [isMobileFilterOpen, setIsMobileFilterOpen] = useState(false)
	const translate = useTranslate()

	return (
		<div className={clsx(style.wrapper, isLocked && style.wrapperLocked)}>
			<Hidden breakpoint="desktopDown">
				{productFilterControl && (
					<ProductFilterControlPanel openModal={openLoginModal} control={productFilterControl} isLocked={isLocked} />
				)}
			</Hidden>

			<Hidden breakpoint="desktopUp">
				<div className={style.buttonWrapperMobile}>
					<button
						className={style.buttonMobile}
						onClick={isLocked ? openLoginModal : () => setIsMobileFilterOpen(true)}
					>
						<SvgFilter />
						<span className={clsx(style.buttonText, isLocked && style.buttonTextLocked)}>{title}</span>
					</button>
				</div>
				<Modal close={() => setIsMobileFilterOpen(false)} isOpen={isMobileFilterOpen} type="filter">
					{productFilterControl && <ProductFilterControlPanel control={productFilterControl} />}
					<div className={style.buttonGroup}>
						<div className={style.buttonFootWrapper}>
							<Button
								label={translate('advancedFilter.button.close')}
								type={{ variant: 'naked' }}
								onClick={() => setIsMobileFilterOpen(false)}
							/>
						</div>
						<div className={style.buttonFootWrapper}>
							<Button
								type={{ fullWidth: true }}
								label={
									<>
										{isLoading ? (
											<>
												{translate('checkboxGroup.modal.button.apply')}
												<span className={style.loader}>
													<LoadingSpinner active={isLoading} />
												</span>
											</>
										) : typeof productsTotal === 'number' ? (
											`${translate('checkboxGroup.modal.button.apply')} (${productsTotal})`
										) : (
											translate('checkboxGroup.modal.button.apply')
										)}
									</>
								}
								onClick={() => setIsMobileFilterOpen(false)}
							/>
						</div>
					</div>
				</Modal>
			</Hidden>
		</div>
	)
}
